export const CLIENT = {
  local: 'local.salesclue',
  dev: 'dev.salesclue',
  release: 'alpha.salesclue',
  main: 'app.salesclue',
};

export const VIEWER = {
  local: 'localhost',
  dev: 'dev.sclu.io',
  release: 'alpha.sclu.io',
  main: 'sclu.io',
};
